import React from "react";
import {
  Input,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import http from "../../services/http";
import { getAPIURL, getUserID, getVendorID } from "../../services/helper";
import {
  setLoading,
  updateRegister,
} from "../../ReduxToolkit/Reducers/AppReducer";

const api_url = getAPIURL();
const vendor_id = getVendorID();
const biller_id = getUserID();

const SetRegisterAmountView = () => {
  const dispatch = useDispatch();
  const { register_id } = useSelector((state) => state.cart);
  const [initialCash, setInitialCash] = React.useState("");

  const openRegister = async () => {
    if (!initialCash || initialCash <= 0) {
      toast.error("Please enter a valid initial amount.");
      return;
    }

    dispatch(setLoading(true));

    try {
      const payload = {
        initial_cash: parseFloat(initialCash),
        register_id,
      };

      const { data: new_register } = await http.post(
        `${api_url}/set-register-amount`,
        payload
      );

      dispatch(setLoading(false));

      if (!new_register.success) {
        toast.error(new_register.data);
        return;
      }

      dispatch(updateRegister(new_register.data));
      toast.success(`Register amount is set.`);
    } catch (error) {
      toast.error("Failed to open register. Please try again.");
      dispatch(setLoading(false));
    }
  };

  return (
    <Card className="shadow-sm">
      <CardBody>
        <h5 className="mb-4">Set Register Amount</h5>
        <Row>
          <Col md="6" className="mb-3 mb-md-0">
            <FormGroup className="mb-0">
              <Input
                type="number"
                id="initialCash"
                placeholder="Enter initial cash amount"
                value={initialCash}
                onChange={(e) => setInitialCash(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <Button color="primary" onClick={openRegister}>
              Set Amount
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default SetRegisterAmountView;
